import React from "react";

export default function PaperTrading() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Image */}
      <div
        className="relative h-[60vh] w-full"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/Trading2.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black/40" />
      </div>

      {/* Text Content Overlay */}
      <div className="bg-black px-6 md:px-16 pt-12 pb-4 text-center max-w-4xl mx-auto rounded-lg -mt-20 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-purple-400 mb-6">
          4-Week Paper Trading Challenge
        </h1>
        <p className="text-gray-300 leading-relaxed text-lg mb-6">
          I topped my ECN 440 class by earning the highest portfolio return in a simulated stock market challenge using $10,000 virtual capital over four weeks.
        </p>
        <ul className="list-disc list-outside pl-6 text-left text-gray-300 text-lg space-y-4 mb-6">
          <li><strong>Week 1:</strong> Focused on health care stocks as defensive plays in a volatile market.</li>
          <li><strong>Week 2:</strong> Chose fundamentally strong stocks based on ROE, P/E, and dividend yield.</li>
          <li><strong>Week 3:</strong> Shorted overhyped speculative stocks, securing a $757 profit.</li>
          <li><strong>Week 4:</strong> Balanced strategy combining tech giants and short trades — finishing with a $1,545 gain.</li>
        </ul>
        <p className="text-gray-300 leading-relaxed text-base mb-6">
          The experience sharpened my skills in technical analysis, risk management, and trading psychology — resulting in a total 14% gain and first place in the class rankings.
        </p>

        {/* Image + Button */}
        <div className="flex flex-col items-center gap-6 mb-20">
          <a href={`${process.env.PUBLIC_URL}/ECN 440 Game Report-Peeris-Mithil.pdf`} download>
            <button className="mt-4 border border-purple-600 px-6 py-4 md:px-8 md:py-4 rounded-full font-semibold text-purple-600 hover:bg-purple-600 hover:text-white transition text-sm md:text-base">
              📄 Download Paper
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}